<fuse-loading-bar></fuse-loading-bar>

<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [appearance]="'default'"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="dense-nav-header">
            <div class="dense-nav-logo">
                <img class="w-12" src="images/logo/dp_logo.png" alt="District Printing" />
            </div>

            <div *ngIf="canUseCompanyPicker" class="dense-company-picker">
                <div class="dense-company-picker__label">Active company</div>
                <button
                    type="button"
                    class="dense-company-picker__trigger"
                    [class.dense-company-picker__trigger--open]="companyPickerOpen"
                    [attr.aria-expanded]="companyPickerOpen"
                    (click)="toggleCompanyPicker()"
                >
                    <span class="dense-company-logo">
                        <span>{{ initials(selectedCompanyLabel) }}</span>
                        <img
                            *ngIf="selectedCompanyLogo"
                            [src]="selectedCompanyLogo"
                            [alt]="selectedCompanyLabel"
                        />
                    </span>
                    <span class="dense-company-picker__identity">
                        <span class="dense-company-picker__company">{{ selectedCompanyLabel }}</span>
                        <span class="dense-company-picker__person">
                            <span class="dense-company-profile">
                                <span>{{ initials(selectedUserName) }}</span>
                                <img
                                    *ngIf="selectedProfileImage"
                                    [src]="selectedProfileImage"
                                    [alt]="selectedUserName"
                                />
                            </span>
                            <span class="dense-company-person-name">{{ selectedUserName }}</span>
                            <span class="dense-company-picker__role">{{ selectedUserRole }}</span>
                        </span>
                    </span>
                    <mat-icon class="dense-company-picker__chevron">
                        {{ companyPickerOpen ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                </button>

                <div
                    *ngIf="companyPickerOpen"
                    class="dense-company-picker__options"
                    aria-label="Choose active company"
                >
                    <button
                        type="button"
                        class="dense-company-option"
                        [class.dense-company-option--active]="!assistCompany"
                        (click)="selectCompany(null)"
                    >
                        <span class="dense-company-logo">
                            <span>{{ initials(selfCompanyLabel) }}</span>
                            <img [src]="selfCompanyLogo" [alt]="selfCompanyLabel" />
                        </span>
                        <span class="dense-company-option__identity">
                            <span class="dense-company-option__company">{{ selfCompanyLabel }}</span>
                            <span class="dense-company-option__person">
                                <span class="dense-company-profile">
                                    <span>{{ initials(selfUserName) }}</span>
                                    <img
                                        *ngIf="selfProfileImage"
                                        [src]="selfProfileImage"
                                        [alt]="selfUserName"
                                    />
                                </span>
                                <span class="dense-company-person-name">{{ selfUserName }}</span>
                                <span class="dense-company-option__role">{{ selfUserRole }}</span>
                            </span>
                        </span>
                    </button>

                    <button
                        *ngFor="let company of assistCompanies"
                        type="button"
                        class="dense-company-option"
                        [class.dense-company-option--active]="isAssistCompanyActive(company)"
                        (click)="selectCompany(company)"
                    >
                        <span class="dense-company-logo">
                            <span>{{ initials(companyMenuLabel(company)) }}</span>
                            <img
                                *ngIf="company.company_logo"
                                [src]="company.company_logo"
                                [alt]="companyMenuLabel(company)"
                            />
                        </span>
                        <span class="dense-company-option__identity">
                            <span class="dense-company-option__heading">
                                <span class="dense-company-option__company">{{ companyMenuLabel(company) }}</span>
                                <mat-icon
                                    class="dense-company-option__mail"
                                    [class.dense-company-option__mail--linked]="company.email_token"
                                    [class.dense-company-option__mail--missing]="!company.email_token"
                                    [matTooltip]="company.email_token ? 'Mailbox connected' : 'No mailbox connected'"
                                >
                                    {{ company.email_token ? 'mail' : 'mail_off' }}
                                </mat-icon>
                            </span>
                            <span class="dense-company-option__person">
                                <span class="dense-company-profile">
                                    <span>{{ initials(companyUserName(company)) }}</span>
                                    <img
                                        *ngIf="companyProfileImage(company)"
                                        [src]="companyProfileImage(company)"
                                        [alt]="companyUserName(company)"
                                    />
                                </span>
                                <span class="dense-company-person-name">{{ companyUserName(company) }}</span>
                                <span class="dense-company-option__role">{{ companyUserRole(company) }}</span>
                            </span>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<div class="layout-main layout-main-root flex w-full min-w-0 flex-auto flex-col">

    <mat-drawer-container class="flex-auto layout-main-drawer" [hasBackdrop]="false">

        <mat-drawer-content class="flex flex-col layout-main-content">
            <div
                class="layout-topbar-unified relative z-49 flex h-16 w-full flex-0 items-center px-4 md:px-6 lg:pr-3 print:hidden"
            >
                <div class="flex items-center space-x-2 pr-2">
                    <button
                        mat-icon-button
                        (click)="toggleNavigation('mainNavigation')"
                    >
                        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                    </button>
                </div>
                <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
                    <div class="hidden lg:flex items-center text-sm text-secondary tabular-nums mr-1">
                        {{ currentTopbarTime }}
                    </div>
                    <!-- Add Order Button -->
                    <button mat-icon-button [routerLink]="['/orders/new']" [matTooltip]="'Add new order'">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                    </button>
                    <!-- TEMP: Add user button hidden until we find a better
                         home for it. Restore by removing this comment wrap. -->
                    <!-- <add-user-button></add-user-button> -->
                    <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                    <!-- <search [appearance]="'bar'"></search>
                    <shortcuts></shortcuts> -->
                    <voice-calls></voice-calls>
                    <!-- TEMP: Video call button hidden until the feature is
                         working well. Restore by removing this comment wrap. -->
                    <!-- <video-calls></video-calls> -->
                    <messages></messages>
                    <timeline-activities></timeline-activities>
                    <updates-required></updates-required>
                    <!-- <notifications></notifications> -->
                    <!-- OpenAI mic button (dormant — uncomment to re-enable)
                    <button
                        mat-icon-button
                        class="mcp-nav-mic"
                        [class.mcp-nav-mic-live]="(mcpRealtime.activeSegmentId$ | async) === 'openai' && (mcpRealtime.status$ | async) === 'active' && !(mcpRealtime.micMuted$ | async)"
                        [class.mcp-nav-mic-muted]="(mcpRealtime.activeSegmentId$ | async) === 'openai' && (mcpRealtime.status$ | async) === 'active' && (mcpRealtime.micMuted$ | async)"
                        [class.mcp-nav-mic-connecting]="(mcpRealtime.activeSegmentId$ | async) === 'openai' && (mcpRealtime.status$ | async) === 'connecting'"
                        (click)="toggleMcpMic()"
                        [matTooltip]="(mcpRealtime.activeSegmentId$ | async) === 'openai' ? ((mcpRealtime.status$ | async) !== 'active' ? 'Start OpenAI mic' : (mcpRealtime.micMuted$ | async) ? 'OpenAI muted - click to unmute' : 'OpenAI listening - click to mute') : 'Switch to OpenAI mic'"
                    >
                        <mat-icon>mic</mat-icon>
                    </button>
                    -->
                    @if (agentEnabled) {
                    <!-- Gemini mic button -->
                    <button
                        mat-icon-button
                        class="mcp-nav-mic"
                        [class.mcp-nav-mic-live]="(mcpRealtime.activeSegmentId$ | async) === 'gemini' && (mcpRealtime.status$ | async) === 'active' && !(mcpRealtime.micMuted$ | async)"
                        [class.mcp-nav-mic-muted]="(mcpRealtime.activeSegmentId$ | async) === 'gemini' && (mcpRealtime.status$ | async) === 'active' && (mcpRealtime.micMuted$ | async)"
                        [class.mcp-nav-mic-connecting]="(mcpRealtime.activeSegmentId$ | async) === 'gemini' && (mcpRealtime.status$ | async) === 'connecting'"
                        (click)="toggleGeminiMic()"
                        [matTooltip]="(mcpRealtime.activeSegmentId$ | async) === 'gemini' ? ((mcpRealtime.status$ | async) !== 'active' ? 'Start Gemini mic' : (mcpRealtime.micMuted$ | async) ? 'Gemini muted - click to unmute' : 'Gemini listening - click to mute') : 'Switch to Gemini mic'"
                    >
                        <mat-icon>
                            {{
                                (mcpRealtime.activeSegmentId$ | async) === 'gemini' && (mcpRealtime.status$ | async) === 'connecting'
                                    ? 'hourglass_empty'
                                    : (mcpRealtime.activeSegmentId$ | async) === 'gemini' && (mcpRealtime.status$ | async) === 'active' && !(mcpRealtime.micMuted$ | async)
                                        ? 'mic'
                                        : (mcpRealtime.activeSegmentId$ | async) === 'gemini' && (mcpRealtime.status$ | async) === 'active'
                                            ? 'mic_off'
                                            : 'graphic_eq'
                            }}
                        </mat-icon>
                    </button>
                    <!-- MCP Drawer toggle -->
                    <button mat-icon-button (click)="mcpDrawer.toggle()" [matTooltip]="'AI Assistant Panel'">
                        <mat-icon>auto_awesome</mat-icon>
                    </button>
                    }

                    <button
                        class="lg:hidden"
                        mat-icon-button
                        (click)="quickChat.toggle()"
                    >
                        <mat-icon
                            [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                        ></mat-icon>
                    </button>
                    <user></user>
                </div>
            </div>

            <div class="layout-page-shell layout-main-outlet flex flex-auto flex-col lg:pr-[var(--quick-chat-rail-width)]">
                <div class="layout-page-ambient" aria-hidden="true">
                    <div class="layout-page-ambient__wash"></div>
                </div>
                <div class="layout-page-content flex flex-auto flex-col min-h-0">
                    @if (true) {
                        <router-outlet></router-outlet>
                    }
                </div>
            </div>

        </mat-drawer-content>

        <mat-drawer #profileDrawer class="w-full md:w-160" [mode]="'over'" [position]="'start'">
            <div class="flex flex-col h-full overflow-hidden">
                <div class="flex items-center justify-between flex-shrink-0 px-8 pt-8 pb-4">
                    <h2 class="text-2xl font-semibold">My Profile</h2>
                    <button mat-icon-button (click)="profileDrawer.close()">
                        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                    </button>
                </div>
                <div class="flex-1 min-h-0 overflow-hidden">
                    @defer (on timer(1s)) {
                        <quick-add-user 
                            [editMode]="true" 
                            [userId]="null"
                            (closeDrawer)="profileDrawer.close()">
                        </quick-add-user>
                    }
                </div>
            </div>
        </mat-drawer>

    </mat-drawer-container>

</div>

<quick-chat #quickChat="quickChat"></quick-chat>
<app-active-call></app-active-call>
<mcp-drawer #mcpDrawer></mcp-drawer>
